/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Desired lifecycle state for an application.
 */
export enum ApplicationDesiredState {
  ApplicationDesiredStateRunning = 'running',
  ApplicationDesiredStateStopped = 'stopped',
}
